import Link from '@alltrails/shared/denali/components/Link';
import Button from '@alltrails/shared/denali/components/Button';
import TermsOfService from 'components/TermsOfService';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import { wrapUrlSafe } from 'utils/language_support_util';
import { appleHandler, facebookHandler, googleHandler } from 'utils/OAuthHandlers';
import AltLoginsForm from 'components/AltLoginsForm';
import User from '@alltrails/shared/types/User';
import EmailPasswordLogin from 'components/EmailPasswordLogin';
import { GoogleLoginResponse } from 'react-google-login';
import LoginResponse from 'types/LoginResponse';
import Typography from 'components/Typography';
import * as styles from './LoginForm.module.scss';

type Props = {
  handleLoginSuccess?: ({ user }: { user: User }) => void;
  returnTo?: string; // url
  useReactRouter?: boolean;
};

function LoginForm({ handleLoginSuccess, returnTo = '/', useReactRouter }: Props) {
  const languageRegionCode = useLanguageRegionCode();

  function loginSuccessCallback(data: LoginResponse) {
    if (handleLoginSuccess) {
      return handleLoginSuccess(data);
    }

    const destinationUrl = returnTo || wrapUrlSafe('/', languageRegionCode);
    window.location.href = data.welcome_notice
      ? `${destinationUrl + (destinationUrl.includes('?') ? '&' : '?')}welcome=${data.welcome_notice}`
      : destinationUrl;
    return undefined;
  }

  async function handleGoogle(response: GoogleLoginResponse) {
    loginSuccessCallback(await googleHandler(response, 'login'));
  }

  function handleFacebook(response: any) {
    facebookHandler(
      response,
      languageRegionCode,
      loginSuccessCallback,
      () => {},
      () => {},
      'login'
    );
  }

  function handleApple() {
    appleHandler();
  }

  return (
    <div className={styles.content}>
      <Typography className={styles.heading} component="div" variant="heading400">
        <FormattedMessage defaultMessage="Welcome back." />
        <br />
        <FormattedMessage defaultMessage="Log in and start exploring." />
      </Typography>
      <div>
        <EmailPasswordLogin handleLoginSuccess={loginSuccessCallback} returnTo={returnTo} />
        <div className={styles.forgotPassword}>
          <Button
            text={<FormattedMessage defaultMessage="Forgot your password?" />}
            linkInfo={{ href: wrapUrlSafe('/users/password/new', languageRegionCode) }}
            testId="login-forgot-password"
            variant="flat"
            width="full"
            allowWrap
          />
        </div>
      </div>
      <div className={styles.gap}>
        <AltLoginsForm appleLoginHandler={handleApple} facebookLoginHandler={handleFacebook} googleLoginHandler={handleGoogle} />
        <div>
          <Typography color="secondary" variant="text200">
            <FormattedMessage defaultMessage="Don't have an account?" />
          </Typography>{' '}
          <Link href="/signup" useReactRouter={useReactRouter} variant="default">
            <FormattedMessage defaultMessage="Sign up for free" />
          </Link>
        </div>
        <div>
          <TermsOfService />
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
